import { Component, ReactNode } from "react"

import Checkbox from "../../libs/ui/inputs/Checkbox"
import Input from "../../libs/ui/inputs/Input"

import { getSvgError } from "../../libs/ui/icons/svg"

export type RilevanzaType = {
    id?: number | undefined
    prezzo: boolean
    franchigia: boolean
    massimale: boolean
    completezza: boolean
    flagAltro: boolean
    altro: string | undefined
}

export function getEmptyRilevanza () : RilevanzaType {
    return {
        prezzo: false,
        franchigia: false,
        massimale: false,
        completezza: false,
        flagAltro: false,
        altro: undefined,
    }
}


type RilevanzaPolizzaProps = RilevanzaType & {
    callBack: Function
    error?: string
}

type RilevanzaState = RilevanzaType & {
    chekedCount: number
}

const initValues : RilevanzaState = {
    ...getEmptyRilevanza(),
    ...{
        chekedCount: 0
    }
}

class RilevanzaPolizza extends Component <RilevanzaPolizzaProps, RilevanzaState> {

    constructor (props: any) {
        super(props)

        this.state = {
            ...initValues,
            ...props
        }


        this.getCurrentState = this.getCurrentState.bind(this)
        this.canCheck = this.canCheck.bind(this)
        this.setInitialCount = this.setInitialCount.bind(this)
        this.getNextCheckedCount = this.getNextCheckedCount.bind(this)
        this.onPrezzoChange = this.onPrezzoChange.bind(this)
        this.onFranchigiaChange = this.onFranchigiaChange.bind(this)
        this.onMassimaleChange = this.onMassimaleChange.bind(this)
        this.onCompletezzaChange = this.onCompletezzaChange.bind(this)
        this.onFlagAltroChange = this.onFlagAltroChange.bind(this)
        this.onAltroChange = this.onAltroChange.bind(this)
    }

    componentDidMount (): void {
        this.setInitialCount( this.props )
    }

    private getCurrentState () {
        return {
            prezzo: this.state.prezzo,
            franchigia: this.state.franchigia,
            massimale: this.state.massimale,
            completezza: this.state.completezza,
            flagAltro: this.state.flagAltro,
            altro: this.state.flagAltro ? this.state.altro : undefined,
            chekedCount: this.state.chekedCount,
        }
    }


    private canCheck ( val : boolean ) {
        return val !== true || this.state.chekedCount < 2
    }

    private setInitialCount (props: RilevanzaPolizzaProps) {
        let count = 0

        if (props.prezzo === true) {
            count++
        }
        if (props.franchigia === true) {
            count++
        }
        if (props.massimale === true) {
            count++
        }
        if (props.completezza === true) {
            count++
        }
        if (props.flagAltro === true) { //  && !isEmpty( props.altro )
            count++
        }

        this.setState({
            ...this.getCurrentState(),
            ...{
                chekedCount: count
            }
        })
        
    }

    private getNextCheckedCount ( val: boolean ) {
        let count = (val) ? this.state.chekedCount + 1 : this.state.chekedCount - 1
        if ( count < 0 ) {
            count = 0
        }
        if( count > 5 ) {
            count = 5
        }

        return count
    }


    private onPrezzoChange ( val: boolean ) {
        if (!this.canCheck( val )) {
            return
        }

        const next = {
            ...this.getCurrentState(),
            ...{
                prezzo: val,
                chekedCount: this.getNextCheckedCount( val )
            }
        }

        this.setState( next )
        this.props.callBack( next )
    }
    private onFranchigiaChange ( val: boolean ) {
        if (!this.canCheck( val )) {
            return
        }

        const next ={
            ...this.getCurrentState(),
            ...{
                franchigia: val,
                chekedCount: this.getNextCheckedCount( val )
            }
        }

        this.setState( next )
        this.props.callBack( next )
    }
    private onMassimaleChange ( val: boolean ) {
        if (!this.canCheck( val )) {
            return
        }
        
        const next ={
            ...this.getCurrentState(),
            ...{
                massimale: val,
                chekedCount: this.getNextCheckedCount( val )
            }
        }

        this.setState( next )
        this.props.callBack( next )
    }
    private onCompletezzaChange ( val: boolean ) {
        if (!this.canCheck( val )) {
            return
        }
        
        const next = {
            ...this.getCurrentState(),
            ...{
                completezza: val,
                chekedCount: this.getNextCheckedCount( val )
            }
        }

        this.setState( next )
        this.props.callBack( next )
    }
    private onFlagAltroChange ( val: boolean ) {
        if (!this.canCheck( val )) {
            return
        }
        
        let next = {
            ...this.getCurrentState(),
            ...{
                flagAltro: val,
                chekedCount: this.getNextCheckedCount( val )
            }
        }

        if (!val) {
            next = {
                ...next,
                ...{
                    altro: undefined
                }
            }
        }

        this.setState( next )
        this.props.callBack( next )
    }
    private onAltroChange ( val: string | undefined ) {
        if (this.state.flagAltro) {

            const next = {
                ...this.getCurrentState(),
                ...{
                    altro: val
                }
            }

            this.setState( next )
            this.props.callBack( next )

        }
    }


    render(): ReactNode {
        return (
            <>
                <p>
                    Cosa ritieni più rilevante nella stipula di un'assicurazione (indicare al massimo due opzioni)?
                </p>
                { this.props.error === 'Selezionare almeno una voce' &&
                    <p className="is-invalid">
                        {getSvgError()} Selezionare almeno una voce
                    </p>
                }
                <div className="container">
                    <div className="row">

                        <div className="col-6 form-group">
                            <Checkbox 
                                id="rilevanza-prezzo" key="rilevanza-prezzo" name="rilevanza-prezzo"
                                checked={ this.state.prezzo }
                                callback={ this.onPrezzoChange }
                            >
                                Prezzo
                            </Checkbox>
                        </div>
                            
                        <div className="col-6 form-group">
                            <Checkbox 
                                id="rilevanza-franchigia" key="rilevanza-franchigia" name="rilevanza-franchigia"
                                checked={ this.state.franchigia }
                                callback={ this.onFranchigiaChange }
                            >
                                Franchigia
                            </Checkbox>
                        </div>

                        <div className="col-6 form-group">
                            <Checkbox 
                                id="rilevanza-massimale" key="rilevanza-massimale" name="rilevanza-massimale"
                                checked={ this.state.massimale }
                                callback={ this.onMassimaleChange }
                            >
                                Massimale
                            </Checkbox>
                        </div>

                        <div className="col-6 form-group">
                            <Checkbox 
                                id="rilevanza-completezza" key="rilevanza-completezza" name="rilevanza-completezza"
                                checked={ this.state.completezza }
                                callback={ this.onCompletezzaChange }
                            >
                                Completezza delle garanzie
                            </Checkbox>
                        </div>

                        <div className="col-12 form-group">

                            <Checkbox 
                                id="rilevanza-flagAltro" key="rilevanza-flagAltro" name="rilevanza-flagAltro"
                                checked={ this.state.flagAltro }
                                callback={ this.onFlagAltroChange }
                            >
                                Altro
                            </Checkbox>

                        </div>
                        { this.state.flagAltro && 
                            <div className="col-12 form-group">
                                <Input 
                                    id="rilevanza-altro" key="rilevanza-altro" name="rilevanza-altro"
                                    label='(specificare "Altro")'
                                    value={ this.state.altro ?? '' }
                                    error={
                                        (this.props.error && this.props.error !== 'Selezionare almeno una voce')
                                            ? 'Compilare il campo'
                                            : undefined
                                    }
                                    callback={ this.onAltroChange }
                                    maxLength={ 100 }
                                />
                            </div>
                        }
                    </div>

                </div>
            </>
        )
    }
}

export default RilevanzaPolizza